module.exports = __webpack_public_path__ + "assets/7422a4b71cd9c09f74c9c7a7b6823bf7.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/drop/DASS/DASS05.mp3
 ** module id = 214
 ** module chunks = 0
 **/